<template>
  <v-container>
    <v-row class="mb-n6">
      <v-col>
        <p>ແກ້ໄຂຂໍ້ມູນລູກຄ້າທຸລະກິດ (ລໍຖ້າອະນຸມັດ)</p>
      </v-col>
    </v-row>

    <v-card class="mt-6">
      <v-tabs v-model="tab">
        <v-tab>ເລືອກລູກຄ້າເພື່ອແກ້ໄຂ</v-tab>
        <v-tab>ຄຳຂໍແກ້ໄຂຂອງຂ້ອຍ</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card-title>
            <v-text-field
              v-model="customerFilter"
              append-icon="mdi-magnify"
              label="ຄົ້ນຫາ ຊື່, ເບີໂທ ຫຼື ລະຫັດລູກຄ້າ"
              single-line
              hide-details
              clearable
              @keyup.enter="fetchCustomers(1)"
              @click:clear="customerFilter = ''; fetchCustomers(1)"
            />
          </v-card-title>
          <v-data-table
            :headers="customerHeaders"
            :items="customers"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:[`item.id`]="{ item }">
              COM_{{ item.id }}
            </template>
            <template v-slot:[`item.phone`]="{ item }">
              {{ item.user ? item.user.phone : '' }}
            </template>
            <template v-slot:[`item.cost_by`]="{ item }">
              {{ costName(item.cost_by) }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-chip
                v-if="item.open_edit_request_id"
                small
                label
                color="warning"
              >
                ມີຄຳຂໍແກ້ໄຂຄ້າງຢູ່
              </v-chip>
              <v-btn
                v-else
                small
                text
                color="primary"
                @click="$router.push({ name: 'CreateCompanyEditRequest', params: { customerId: item.id } })"
              >
                <v-icon
                  small
                  left
                >
                  mdi-pencil
                </v-icon>
                ແກ້ໄຂ
              </v-btn>
            </template>
          </v-data-table>
          <Pagination
            v-if="customerPagination.total_pages > 1"
            :pagination="customerPagination"
            :offset="offset"
            @paginate="fetchCustomers()"
          />
        </v-tab-item>

        <v-tab-item>
          <v-data-table
            :headers="requestHeaders"
            :items="requests"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:[`item.customer_id`]="{ item }">
              COM_{{ item.customer_id }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                :color="item.status === 'rejected' ? 'error' : 'warning'"
                label
                small
              >
                {{ item.status === 'rejected' ? 'ຖືກປະຕິເສດ' : 'ລໍຖ້າອະນຸມັດ' }}
              </v-chip>
            </template>
            <template v-slot:[`item.reject_reason`]="{ item }">
              <span class="error--text">{{ item.reject_reason }}</span>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-btn
                small
                text
                color="primary"
                @click="$router.push({ name: 'EditCompanyEditRequest', params: { id: item.id } })"
              >
                <v-icon
                  small
                  left
                >
                  mdi-pencil
                </v-icon>
                {{ item.status === 'rejected' ? 'ແກ້ໄຂ ແລະ ສົ່ງໃໝ່' : 'ແກ້ໄຂ' }}
              </v-btn>
            </template>
          </v-data-table>
          <Pagination
            v-if="requestPagination.total_pages > 1"
            :pagination="requestPagination"
            :offset="offset"
            @paginate="fetchRequests()"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import { COSTS } from './editFields';

export default {
  title() {
    return 'Vientiane Waste Co-Dev|Company Edit Request';
  },
  data() {
    return {
      tab: 0,
      offset: 12,
      customers: [],
      customerFilter: '',
      customerPagination: {},
      customerSeq: 0,
      requests: [],
      requestPagination: {},
      requestSeq: 0,
      customerHeaders: [
        { text: 'ລະຫັດ', value: 'id' },
        { text: 'ຊື່ບໍລິສັດ', value: 'company_name' },
        { text: 'ເບີໂທ', value: 'phone', sortable: false },
        { text: 'ປະເພດບໍລິການ', value: 'cost_by', sortable: false },
        { text: '', value: 'action', sortable: false },
      ],
      requestHeaders: [
        { text: 'ລະຫັດ', value: 'customer_id' },
        { text: 'ຊື່ບໍລິສັດ', value: 'company_name' },
        { text: 'ສະຖານະ', value: 'status' },
        { text: 'ເຫດຜົນທີ່ປະຕິເສດ', value: 'reject_reason', sortable: false },
        { text: 'ວັນທີສົ່ງ', value: 'created_at' },
        { text: '', value: 'action', sortable: false },
      ],
    };
  },
  created() {
    this.fetchCustomers();
    this.fetchRequests();
  },
  methods: {
    costName(value) {
      return COSTS[value] || value;
    },
    fetchCustomers(page) {
      // Ignore responses to superseded searches (the API can be slow).
      const seq = ++this.customerSeq;
      if (page) this.$set(this.customerPagination, 'current_page', page);
      this.$axios
        .get('company-edit-request/customers', {
          params: {
            page: this.customerPagination.current_page,
            per_page: 20,
            filter: this.customerFilter || undefined,
          },
        })
        .then((res) => {
          if (seq !== this.customerSeq) return;
          this.customers = res.data.data.data;
          this.customerPagination = res.data.data.pagination;
        });
    },
    fetchRequests() {
      const seq = ++this.requestSeq;
      this.$axios
        .get('company-edit-request', {
          params: { page: this.requestPagination.current_page, per_page: 20 },
        })
        .then((res) => {
          if (seq !== this.requestSeq) return;
          this.requests = res.data.data.data;
          this.requestPagination = res.data.data.pagination;
        });
    },
  },
};
</script>
